// extracted by mini-css-extract-plugin
export default {"userSearch":"users_userSearch__B6n6F","userSelect":"users_userSelect__ipOYT"};